module.exports = __webpack_public_path__ + "static/media/icon.7bb4ae79.svg";